exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-panel-inner[data-v-624246bb]{background-color:#c1c1c196;padding:1rem}.search-panel-inner[data-v-624246bb] .search-input{height:48px;line-height:48px;border-radius:0}.search-panel-inner[data-v-624246bb] .featured-search-wrapper{column-count:1}", ""]);

// exports
